import { Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React, { useState } from 'react';
import Template_Card from '../components/Template_Card';
import gold from '../Assets/gold1.jpg';  // Example image
import instance from '../Utils/api';

const NewArrivals = () => {
    const [data, setData] = useState();
    // const [update, setUpdate] = useState(false);

    const getproductsData = async () => {
        try {
            const response = await instance.get('/getProduct');
            console.log(response.data);
            setData(response.data.products)
        } catch (error) {
            console.log(error);
        }
    }
    useState(() => {
        getproductsData();
    }, [])

    return (
        <Grid container spacing={2} justifyContent="center">
            {data?.map((item) => (
                <Grid item key={item._id} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Template_Card data={item} setUpdate={getproductsData} />
                </Grid>
            ))}
        </Grid>
    );
};

export default NewArrivals;
